import { cx } from "src-lib/util/css/util";
// @ts-ignore
import * as Surplus from "surplus";
import { ImgButtonProps } from "./primitive-wrappers";
import { InlineSVG } from "./svg-util";

export function IconPlus(props: JSX.HTMLAttributes<HTMLSpanElement>) {
    return (
        <SVGIcon {...props}>
            <SVG.Plus />
        </SVGIcon>
    );
}

export function IconMinus(props: JSX.HTMLAttributes<HTMLSpanElement>) {
    return (
        <SVGIcon {...props}>
            <SVG.Minus />
        </SVGIcon>
    );
}

export function IconVertEllipsis(props: JSX.HTMLAttributes<HTMLSpanElement>) {
    return (
        <SVGIcon {...props}>
            <SVG.VertEllipsis />
        </SVGIcon>
    );
}

export function IconGithub(props: JSX.HTMLAttributes<HTMLSpanElement>) {
    return (
        <SVGIcon {...props}>
            <SVG.Github />
        </SVGIcon>
    );
}

export function IconLinkedIn(props: JSX.HTMLAttributes<HTMLSpanElement>) {
    return (
        <SVGIcon {...props}>
            <SVG.LinkedIn />
        </SVGIcon>
    );
}

export function IconExternalLink(props: JSX.HTMLAttributes<HTMLSpanElement>) {
    return (
        <SVGIcon {...props}>
            <SVG.ExternalLink />
        </SVGIcon>
    );
}

export function IconMail(props: JSX.HTMLAttributes<HTMLSpanElement>) {
    return (
        <SVGIcon {...props}>
            <SVG.Mail />
        </SVGIcon>
    );
}

export function IconRSSFeed(props: JSX.HTMLAttributes<HTMLSpanElement>) {
    return (
        <SVGIcon {...props}>
            <SVG.RSSFeed />
        </SVGIcon>
    );
}

export function SVGIcon(props: JSX.HTMLAttributes<HTMLSpanElement>) {
    let htmlProps = { ...props };
    delete (htmlProps as any).children;
    delete (htmlProps as any).class;
    return (
        <span class={"icon baseline " + (props.class || "")} {...htmlProps}>
            {props.children}
        </span>
    );
}

export function AExt(props: JSX.HTMLAttributes<HTMLAnchorElement>) {
    let htmlProps = { ...props };
    delete htmlProps.children;
    return (
        <a {...htmlProps} rel="noopener noreferrer" target="_blank">
            {props.children}
        </a>
    );
}

export function ImgAButton(props: JSX.HTMLAttributes<HTMLAnchorElement>) {
    let htmlProps = { ...props };
    delete (htmlProps as any).children;
    return (
        <a class="button button-img" {...htmlProps}>
            <span class="wButton">
                <span class="icon">{props.children}</span>
            </span>
        </a>
    );
}

export function AButton(props: JSX.HTMLAttributes<HTMLAnchorElement>) {
    let htmlProps = { ...props };
    delete (htmlProps as any).children;
    return (
        <a class="button buttonSecondary" {...htmlProps}>
            <span class="wButton">{props.children}</span>
        </a>
    );
}

export function ButtonImg(props: ImgButtonProps & JSX.HTMLAttributes<HTMLButtonElement>) {
    return ButtonBase({ ...props, buttonConfig: "button-img imgButton" });
}

export function ButtonPri(props: JSX.HTMLAttributes<HTMLButtonElement>) {
    return ButtonBase({ ...props, buttonConfig: "" });
}

export function Button(props: JSX.HTMLAttributes<HTMLButtonElement>) {
    return ButtonBase({ ...props, buttonConfig: "buttonSecondary" });
}

export function ButtonClear(props: JSX.HTMLAttributes<HTMLButtonElement>) {
    return ButtonBase({ ...props, buttonConfig: "button-clear" });
}

export function ButtonBase(props: { buttonConfig: string } & JSX.HTMLAttributes<HTMLButtonElement>) {
    let htmlProps = { ...props };
    delete (htmlProps as any).children;
    delete (htmlProps as any).class;

    return (
        <button type="button" {...htmlProps} class={cx(props.buttonConfig, props.class)}>
            <span class="wButton">{props.children}</span>
        </button>
    );
}

export function Tag(props: JSX.HTMLAttributes<HTMLSpanElement>) {
    let htmlProps = { ...props };
    delete (htmlProps as any).children;
    delete (htmlProps as any).class;
    return (
        <span {...htmlProps} class={"span__tag " + (props.class || "")}>
            {props.children}
        </span>
    );
}

export const SVG = {
    Plus: function () {
        return (
            <svg class="svg__plus" width="24" height="24" viewBox="0 0 24 24">
                <use xlinkHref="#plus" />
            </svg>
        );
    },
    Minus: function () {
        return (
            <svg class="svg__minus" width="24" height="24" viewBox="0 0 24 24">
                <use xlinkHref="#minus" />
            </svg>
        );
    },
    Mail: function () {
        return (
            <svg class="svg__mail" width="24" height="24" viewBox="0 0 24 24">
                <use xlinkHref="#mail" />
            </svg>
        );
    },
    Github: function () {
        return (
            <svg class="svg__github" width="42.607px" height="41.555px" viewBox="0 0 42.607 41.555">
                <use xlinkHref="#github" />
            </svg>
        );
    },
    LinkedIn: function () {
        return (
            <svg class="svg__linkedin" width="50.8px" height="50.8px" viewBox="0 0 50.801 50.8">
                <use xlinkHref="#linkedin" />
            </svg>
        );
    },
    ExternalLink: function () {
        return (
            <svg class="svg__external-link" width="24px" height="24px" viewBox="0 0 24 24">
                <use xlinkHref="#external-link" />
            </svg>
        );
    },
    RSSFeed: function () {
        return (
            <svg class="svg__rss-feed" width="24px" height="24px" viewBox="0 0 24 24">
                <use xlinkHref="#rss-feed-icon" />
            </svg>
        );
    },
    VertEllipsis: function () {
        return (
            <svg height="512px" width="512px" viewBox="-192 0 512 512">
                <use xlinkHref="#vert-ellipsis" />
            </svg>
        );
    },
};

export function DottedUnderline(props: { children: any }) {
    return <span class="underline-dot">{props.children}</span>;
}

export function ExtLink(props: JSX.HTMLAttributes<HTMLAnchorElement>) {
    let words = (props.children as string)[0].split(" ");
    console.log("extlink", props.children);
    return (
        <AExt {...props}>
            <span>{words.slice(0, Math.max(1, words.length - 1)).join(" ")}</span>
            <span class="no-wrap">
                {words.length > 1 ? <span>{" " + words[words.length - 1]}</span> : null}
                <IconExternalLink class="ml1" />
            </span>
        </AExt>
    );
}

export function ExtGithub(props: JSX.HTMLAttributes<HTMLAnchorElement>) {
    let words = (props.children as string)[0].split(" ");
    console.log("ExtGithub", words);
    return (
        <AExt {...props}>
            <span>{words.slice(0, Math.max(1, words.length - 1)).join(" ")}</span>
            <span class="no-wrap">
                {words.length > 1 ? <span>{" " + words[words.length - 1]}</span> : null}
                <IconGithub class="ml1" />
            </span>
        </AExt>
    );
}

export function SVGIconDefs() {
    /* tslint:disable */
    return (
        <InlineSVG>
            <g id="github">
                <path
                    d="M21.304 0C9.539 0 0 9.537 0 21.304 0 30.716 6.104 38.7 14.569 41.518c1.064.197 1.455-.462 1.455-1.025 0-.507-.02-2.186-.029-3.966-5.926 1.289-7.177-2.514-7.177-2.514-.969-2.462-2.365-3.117-2.365-3.117-1.933-1.322.145-1.295.145-1.295 2.14.15 3.266 2.196 3.266 2.196 1.9 3.256 4.984 2.315 6.2 1.77.19-1.376.743-2.316 1.352-2.848-4.732-.539-9.706-2.366-9.706-10.528 0-2.326.832-4.227 2.195-5.719-.221-.536-.95-2.703.207-5.637 0 0 1.789-.573 5.86 2.184 1.699-.472 3.521-.71 5.332-.718 1.81.009 3.634.246 5.336.718 4.066-2.757 5.853-2.184 5.853-2.184 1.16 2.934.43 5.1.21 5.637 1.365 1.492 2.191 3.393 2.191 5.719 0 8.182-4.983 9.983-9.727 10.51.764.662 1.445 1.958 1.445 3.946 0 2.85-.025 5.145-.025 5.846 0 .568.384 1.231 1.463 1.023 8.46-2.82 14.557-10.803 14.557-20.212C42.607 9.537 33.07 0 21.304 0"
                    fill-rule="evenodd"
                />
                <path d="M8.069 30.587c-.047.106-.214.138-.365.065-.155-.07-.242-.214-.191-.32.045-.109.212-.14.366-.066.155.07.243.215.19.321M8.932 31.55c-.102.094-.3.05-.435-.099-.14-.148-.166-.347-.063-.443.105-.094.298-.05.437.099.14.15.167.347.06.443M9.772 32.776c-.13.091-.345.006-.476-.183-.131-.19-.131-.417.003-.508.132-.091.342-.009.476.179.13.192.13.42-.003.512M10.922 33.962c-.116.129-.365.094-.547-.082-.186-.172-.238-.415-.121-.544.118-.13.368-.093.552.081.185.172.24.417.116.545M12.51 34.65c-.052.167-.291.242-.532.172-.241-.073-.399-.269-.35-.437.05-.168.29-.247.533-.171.241.072.399.266.349.436M14.254 34.778c.006.175-.2.321-.452.324-.255.006-.461-.136-.464-.31 0-.177.2-.32.454-.325.254-.005.462.136.462.31M15.876 34.502c.03.17-.146.347-.397.394-.248.045-.477-.061-.508-.23-.03-.176.148-.352.395-.398.252-.044.478.06.51.234" />
            </g>
            <g id="linkedin">
                <path d="M43.288 43.288h-7.53v-11.79c0-2.812-.051-6.428-3.915-6.428-3.921 0-4.521 3.063-4.521 6.225v11.993h-7.53V19.045h7.228v3.312h.1c1.006-1.906 3.464-3.915 7.13-3.915 7.63 0 9.038 5.021 9.038 11.548zM11.3 15.731a4.37 4.37 0 0 1 0-8.737 4.37 4.37 0 0 1 4.366 4.367 4.37 4.37 0 0 1-4.366 4.37zm3.765 27.557H7.532V19.045h7.534zM47.04 0H3.75C1.68 0 0 1.64 0 3.661v43.473C0 49.158 1.68 50.8 3.75 50.8h43.29c2.072 0 3.76-1.642 3.76-3.666V3.661C50.8 1.64 49.113 0 47.04 0" />
            </g>
            <g id="external-link">
                <path d="M5 3c-1.093 0-2 .907-2 2v14c0 1.093.907 2 2 2h14c1.093 0 2-.907 2-2v-7h-2v7H5V5h7V3H5zm9 0v2h3.586l-9.293 9.293 1.414 1.414L19 6.414V10h2V3h-7z" />
            </g>
            <g id="cardSuits">
                <path
                    id="suitClub"
                    d="M128.816 160.6c-58.813-28.094-145.327 5.417-124.858 81.012 19.947 73.669 106.09 57.502 135.879 12.659-12.427 85.025-34.252 98.262-47.334 116.72h138.884c-14.072-19.74-39.624-31.695-54.608-117.886 30.016 44.768 120.253 60.288 139.912-12.316 19.338-71.421-67.834-112.095-125.801-79.763C246.475 123.7 266.436 1.113 161.159 1.113c-106.318 0-88.58 124.984-32.343 159.487z"
                    style={{ marker: "none" }}
                    display="block"
                    overflow="visible"
                />
                <path
                    id="suitSpade"
                    d="M825.117 128.697c-122.08 124.722-2.408 215.191 94.114 155.646-18.225 64.968-28.248 70.08-39.312 87.19h104.213c-13.377-17.277-27.426-22.222-41.66-86.82 98.547 56.61 202.41-42.114 93.06-156.016C964.018 66.142 936.253 9.032 930.324.923c-5.689 6.757-39.208 66.38-105.208 127.774z"
                    fill-rule="evenodd"
                />
                <path
                    id="suitHeart"
                    d="M1309.287 370.805c-.343-.618-1.818-5.088-3.278-9.933-9.254-30.706-26.433-61.799-55.2-99.912-10.809-14.319-20.982-26.999-48.49-60.437-31.85-38.718-40.975-51.12-50.188-68.228-5.44-10.103-11.078-25.474-12.934-35.263-1.854-9.783-1.884-25.767-.064-34.09 7.403-33.854 37.475-59.394 73.433-62.368 41.193-3.407 76.232 17.402 94.643 56.207l4.111 8.665 3.095-6.846c4.597-10.171 9.025-17.05 16.498-25.634C1349.941 11.113 1372.587.408 1399.868.37c12.22-.017 19.222.998 29.635 4.293 15.574 4.928 27.298 12.605 37.74 24.713 27.21 31.553 23.987 74.54-9.533 127.187-7.82 12.281-21.928 30.452-41.33 53.232-22.344 26.231-33.26 39.563-44.438 54.265-26.79 35.24-44.81 67.26-54.72 97.243-1.513 4.574-3.097 8.836-3.52 9.471-.986 1.476-3.603 1.494-4.415.031z"
                />
                <path
                    id="suitDiamond"
                    d="M543.994.212c-38.7 64.396-82.264 126.344-126.524 185.84 46.345 59.495 90.605 121.442 126.522 185.84 37.308-65.623 78.092-128.183 126.522-185.84-47.04-59.496-89.91-122.668-126.522-185.84z"
                    fill-rule="evenodd"
                />
            </g>
        </InlineSVG>
    );
    /* tslint:enable */
}
